import { render } from "./TagsCard.vue?vue&type=template&id=28147822"
import script from "./TagsCard.vue?vue&type=script&lang=js"
export * from "./TagsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__